module.exports = __webpack_public_path__ + "img/cart_product_cross.08d26456.svg";